// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XHVuw","col":"styles_col__2F-Lr"};